module.exports = __webpack_public_path__ + "static/media/businessuser.9dd48498.svg";